import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthenticationInfoType } from "../../utility/types";
import EnterOrganizationId from "./EnterOrganizationId";
import ProjectSummaries from "./ProjectSummaries";

import "./Projects.scss";

interface ProjectsProps {
  auth: AuthenticationInfoType;
}

const Projects = ({ auth }: ProjectsProps) => {
  const [organizationId, setOrganizationId] = useState("");
  const navigate = useNavigate();
  const { orgid } = useParams();

  const onEnterOrganizationId = (organizationId: string) => {
    setOrganizationId(organizationId);
    navigate(`/projects/${organizationId}`);
  };

  if (!orgid) {
    return <EnterOrganizationId auth={auth} onFinish={onEnterOrganizationId}></EnterOrganizationId>;
  } else {
    return (
      <div className="projects">
        <h3>Projects from {organizationId}</h3>

        <ProjectSummaries auth={auth} organizationId={organizationId}></ProjectSummaries>
      </div>
    );
  }
};

export default Projects;
